export const REPORTROUTES: any = {
  intervalReport: '/data/intervalreport',
  averageThroughputTime: '/dashboard/avg/throughputTime',
  revenueCustomerHour: '/dashboard/avg/revenue-per-customer/hour',
  revenueCustomerDay: '/dashboard/avg/revenue-per-customer/day'
};
